module.exports = __webpack_public_path__ + "static/David_Shaw_s_10_Property_Cash_Flow_Tips-e0dd0bbd8e910c5e99bfd85af6bbfc30.pdf";